import { msalConfig } from "authConfig";
import { WithChildrenProps } from "types/generalTypes";
import { Navigate } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";

const msalInstance = new PublicClientApplication(msalConfig);
const RequireAuth: React.FC<WithChildrenProps> = ({ children }) => {
  const currentUser: any = localStorage.getItem("loggedInUser");
  const parsedData = JSON.parse(currentUser)
  return parsedData?.accessToken ? (
    <>
      <MsalProvider instance={msalInstance}>{children}</MsalProvider>
    </>
  ) : (
    <Navigate to="/" replace />
  );
};

export default RequireAuth;
